var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserFlow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.800781,
    width: 48,
    height: 48,
    rx: 4.5,
    fill: "#EAECF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2294 21.3768C22.2294 22.8276 23.3806 24.0036 24.8008 24.0036C26.2209 24.0036 27.3722 22.8276 27.3722 21.3768C27.3722 19.9261 26.2209 18.75 24.8008 18.75C23.3806 18.75 22.2294 19.9261 22.2294 21.3768Z",
    fill: "#475467"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008 25.3098C28.0847 25.3098 29.1219 27.4956 29.2787 28.8763C29.3021 29.0821 29.1329 29.25 28.9258 29.25H20.6758C20.4687 29.25 20.2994 29.0821 20.3228 28.8763C20.4796 27.4956 21.5169 25.3098 24.8008 25.3098Z",
    fill: "#475467"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFlow);
export default __webpack_public_path__ + "static/media/user-flow.7e68a6225076fd6d9228e54649b4cb4d.svg";
export { ForwardRef as ReactComponent };